// oversize.mjs
//
// PURE, Node-testable helpers for HONEST 413 reporting. Imported by App.jsx.
//
// The bug they serve: a template whose serialized JSON exceeds the server's
// MAX_SINGLE_PAYLOAD_MB request cap is rejected with 413. On the load-time /
// bulk sync path that failure was SILENT (surface:false) — the mockup saved to
// this device's IndexedDB but never reached the server, so it vanished on every
// other device and left sets pointing at a template that isn't there. Nothing
// told the member. These helpers let the client say exactly WHICH mockup, HOW
// big, and WHICH FIELD blew the budget (the server only knows the body was too
// large; the client holds the object, so it does the breakdown).
//
// TextEncoder is a global in both the browser and Node, so this measures bytes
// the same way the server's byteSize() does.
const _enc = new TextEncoder();
export function byteLen(s) {
  return _enc.encode(s).length;
}

// Measure a template as the server sees it (UTF-8 bytes of its JSON body) and
// find the single field carrying the most bytes — the thing to shrink.
export function templateSizeInfo(tpl) {
  let field = "(unknown)", fieldBytes = 0, totalBytes = 0;
  if (!tpl || typeof tpl !== "object") return { totalBytes: 0, totalMB: 0, field, fieldMB: 0 };
  try {
    totalBytes = byteLen(JSON.stringify(tpl));
    for (const k of Object.keys(tpl || {})) {
      const b = byteLen(JSON.stringify(tpl[k] ?? null));
      if (b > fieldBytes) { fieldBytes = b; field = k; }
    }
  } catch (e) { /* junk input → zeros, never throws */ }
  const mb = (n) => Math.round((n / 1048576) * 100) / 100;
  return { totalBytes, totalMB: mb(totalBytes), field, fieldMB: mb(fieldBytes) };
}
